/*
 * 保存为模板（对齐 Figma）
 *   ┌─────────────────────────────────────────┐
 *   │ 保存成模板，可重复使用            ✦ 推荐  │
 *   │ 下次同样的表 · 10 秒出稿                  │
 *   │ ✓ 这 8 个照片位置      ✓ 「前/后」时序规则 │
 *   │ ✓ 命名方式「排油烟罩等」                  │
 *   │ ┌─────────────────────────────────────┐ │
 *   │ │     保存为「油烟管道清洗模板」          │ │ ← 浅紫色 ghost 按钮
 *   │ └─────────────────────────────────────┘ │
 *   └─────────────────────────────────────────┘
 */

import React, { useState } from 'react'

interface Props {
  data: {
    /** 推荐保存的模板名 */
    suggestedName: string
    /** 副标题：如 "下次同样的表 · 10 秒出稿" */
    description?: string
    /** 复用价值列表（带 ✓ 前缀展示） */
    benefits?: string[]
    /** 标题文案，默认 "保存成模板，可重复使用" */
    title?: string
    /** 是否显示推荐胶囊 */
    recommended?: boolean
  }
  onSave: (name: string) => void
}

export const TemplateSaveCard: React.FC<Props> = ({ data, onSave }) => {
  const [name] = useState(data.suggestedName)

  return (
    <div className="aiClerk-att-template">
      <div className="aiClerk-att-template__head">
        <div className="aiClerk-att-template__title">
          {data.title || '保存成模板，可重复使用'}
        </div>
        {data.recommended !== false && (
          <span className="aiClerk-att-template__tag">✦ 推荐</span>
        )}
      </div>

      {data.description && (
        <div className="aiClerk-att-template__desc">{data.description}</div>
      )}

      {data.benefits && data.benefits.length > 0 && (
        <ul className="aiClerk-att-template__benefits">
          {data.benefits.map((b, i) => (
            <li key={i} className="aiClerk-att-template__benefit">
              <span className="aiClerk-att-template__check">✓</span>
              <span className="aiClerk-att-template__benefit-text">{b}</span>
            </li>
          ))}
        </ul>
      )}

      <button
        type="button"
        className="aiClerk-att-template__btn"
        onClick={() => onSave(name)}
        disabled={!name.trim()}
      >
        保存为模板
      </button>
    </div>
  )
}
